export default __webpack_public_path__ + "static/media/add-liquidity.d25e133f.gif";